module.exports = __webpack_public_path__ + "static/media/moon.1f48d494.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moon.svg
// module id = 590
// module chunks = 1